<template>
  <b-modal id="detView" title="Change Transporter" size="lg" centered v-model="showModal">
    <basic-e-w-b-details v-bind:ewaybill="ewaybill"></basic-e-w-b-details>
    <form class="">
        <label for="newTransporterId">New Transporter</label>
        <select v-model="newTransporterId" id="newTransporterId" class="form-control">
          <option v-for="t of transportersList" :key="t.id" :value="t.gstin">{{t.name}}</option>
        </select>
    </form>
    <br>
    <div v-if="modal.isError">
      <div class="alert alert-danger" role="alert">
        Changing Transporter failed. {{ modal.errorMsg }}
      </div>
    </div>
    <div v-if="modal.isSuccess">
      <div class="alert alert-success" role="alert">
        Transporter Changed.
      </div>
    </div>
    <div v-if="modal.inProgress">
      <div class="text-center">
        Changing Transporter. Please wait...
      </div>
      <br>
      <div class="text-center">
        <span class="fa fa-spinner fa-spin fa-3x"></span>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <button class="btn btn-secondary" @click="closeModal()" v-if="!modal.inProgress">
         <i class="fa fa-times"></i> Dismiss
        </button>
        <button class="btn btn-secondary" @click="closeModal()" v-if="modal.isSuccess">
         <i class="fa fa-times"></i> Close
        </button>
        <button v-if="!modal.isSuccess" :disabled="modal.inProgress" class="btn btn-primary" @click="changeTransporter(ewaybill)">
        <i class="fa fa-person-carry"></i>  Change Transporter
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
import axios from 'axios'
import BasicEWBDetails from '@/components/shared/BasicEWBDetails'

let apiUrl = process.env.NODE_ENV === 'production' ? 'https://api.e-waybill.in' : 'http://localhost:36508'
let uuid = () => {
  return Math.random().toString(36).substring(2, 15)
}

export default {
  name: 'ChangeTransporter',
  components: { BasicEWBDetails },
  props: ['ewaybill', 'credential'],
  created: function () {
    axios.get('/app/party?type=TRANSPORTER')
      .then(response => {
        this.transportersList = response.data
      }, error => {
        console.error('Error in getting transporters list', error)
      })
  },
  data () {
    return {
      showModal: true,
      modal: {
        inProgress: false,
        isError: false,
        isSuccess: false,
        errorMsg: ''
      },
      newTransporterId: '',
      transportersList: []
    }
  },
  methods: {
    changeTransporter: function () {
      let e = this.ewaybill

      if (this.newTransporterId === '') {
        this.modal.isError = true
        this.modal.errorMsg = 'Please select a valid transporter'
        return
      }

      // make update
      let payload = {
        requestId: uuid(),
        credentials: {
          userName: this.credential.userName,
          password: this.credential.password,
          gstNumber: this.credential.gstNumber,
          loginType: 'TXP'
        },
        ewaybillNos: [this.ewaybill.ewb],
        newTransporterId: this.newTransporterId
      }

      this.modal.inProgress = true
      axios.post(`${apiUrl}/api/e-waybill/change`, payload).then(response => {
        // check the status until completed
        let interval = setInterval(() => {
          axios.get(`${apiUrl}/api/e-waybill/change-status?request_id=${payload.requestId}`).then(response => {
            const data = response.data
            if (data.status === 'COMPLETED') {
              clearInterval(interval)
              const ewbStatus = data.changeStatus[e.ewb]
              if (ewbStatus !== undefined) {
                if (ewbStatus) {
                  this.modal.inProgress = false
                  this.modal.isSuccess = true
                  axios.put(`/app/ewb/update-transporter?ewb=${e.ewb}&transporterId=${payload.newTransporterId}`)
                  this.$emit('changeComplete', data)
                } else {
                  this.modal.isError = true
                  this.errorMsg = data.errors[e.ewb]
                }
              }
            }
          })
        }, 5000)
      }, error => {
        console.error('Error in changing transporter', error)
        this.modal.errorMsg = 'Unable to update transporter, Try after sometime'
        this.modal.isError = true
        this.modal.inProgress = false
      })
    },
    closeModal: function () {
      // reset state
      this.modal.inProgress = false
      this.modal.isError = false
      this.modal.isSuccess = false
      this.modal.errorMsg = ''

      this.$emit('dialogClosed', {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/ChangeTransporter.vue